
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {mixins} from "../../assets/js/utils";

export default {
directives: {
TransferDom
},
components: {
CellBox,
Group,
Cell, Flexbox, FlexboxItem, XDialog
},
created () {
this.getInfo();
},
mixins: [mixins],
methods: {
getInfo(){
let shopId = this.shopId;
let id = this.id;
let promoteAccountId = this.promoteAccountId;
let uri = '/v1/shop/'+shopId+"/bill/GET_COMMISSION_BILL_RECORD_DETAIL";
let params = {
"id":id,
"shopId":shopId,
"promoteAccountId":promoteAccountId
};
let _this = this;
_this.axios.post(uri, params, {
headers: {}
}).then(function (response) {
let data = response.data;
if (data.code != undefined && data.code == 0) {
_this.orderInfo = data.data;
} else {
_this.showHideOnBlur = true;
_this.dialogMsg = response.data.msg;
}
}).catch(function (response) {
_this.showHideOnBlur = true;
_this.dialogMsg = response.message;
});
}
},
data () {
return {
dialogMsg: '',
showHideOnBlur:false,
shopId: this.$route.params.shopId,
promoteAccountId: this.$route.params.promoteAccountId,
id: this.$route.params.id,
billNo: 0,
orderInfo: {}
}
},
computed : {
goodsDisType (){
switch (this.orderInfo.goodsDisType){
case 1:
return "大床间（单间）";
case 2:
return "单人间（单间）";
case 3:
return "双床间（单间）";
case 4:
return "三人间（单间）";
case 5:
return "套房";
case 6:
return "独栋";
case 7:
return "床位房";
default:
return "";
}
},
isShowNeedPrice (){
let totalPrice = this.orderInfo.totalPrice;
let needPrice = this.orderInfo.needPrice;
return needPrice != totalPrice;
}
}
}



// WEBPACK FOOTER //
// ./src/components/member/RebateDetail.vue